import React from 'react';
import styles from './Private2.module.css';


const Private2 = () => {
  return (
    <section className={styles.private2Section}>
      <div className={styles.videoContainer}> 
        <video className={styles.video} autoPlay muted loop playsInline>
          <source src='/match-photos.mp4' type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <h1 className={styles.privateTitle} >No need to worry about prying eyes</h1>
      <h2 className={styles.text}>See each other only after matching<br/><br/>We use AI to block human faces from being uploaded as Posts<br/>There is no restriction for Match Photots, which are only visible to matches </h2>
    </section>
  );
};

export default Private2;
